import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import NewData from './NewData';
import Yoga from '../ExtraPages/Yoga';
// import gym1 from '../Images/gym1.jpg';
// import NewData from '../bootstrap/NewData'
const CardsPage = () => {

    // const navigate = useNavigate()
    // const handleLink1=()=>{
    //   navigate("../yoga", { replace: true })
    // }
    // const handleLink2=()=>{
    //     navigate("./gym24")
    //   }
    //   const handleLink3=()=>{
    //     navigate("/allequip")
    //   }
    //   const handleLink4=()=>{
    //     navigate("/trainers")
    //   }
  return (
    <>
    <div className='card-group'>

        <div className="card">
  <img src={NewData.img1} className="card-img-top" alt="..."/>
  <div className="card-body">
    <h5 className="card-title">{NewData.title1}</h5>
    <Link to={"../yoga"}>
    <button className="btn btn-primary">Learn More</button>
</Link>
  
  </div>
</div>
<div className="card">
  <img src={NewData.img2} className="card-img-top" alt="..."/>
  <div className="card-body">
    <h5 className="card-title">{NewData.title2}</h5>
  
    <Link to={"../Gym24"}>
    <button className="btn btn-primary">Learn More</button>
</Link>
  </div>
</div>
<div className="card">
  <img src={NewData.img3} className="card-img-top" alt="..."/>
  <div className="card-body">
    <h5 className="card-title">{NewData.title3}</h5>
  
    <Link to={"../allequip"}>
    <button className="btn btn-primary">Learn More</button>
</Link>
  </div>
</div>
<div className="card">
  <img src={NewData.img4} className="card-img-top" alt="..."/>
  <div className="card-body">
    <h5 className="card-title">{NewData.title4}</h5>
  
    <Link to={"../trainers"}>
    <button className="btn btn-primary">Learn More</button>
</Link>
  </div>
</div>
    </div>
</>
)}

export default CardsPage